// ═══════════════════════════════════════════════════════════════════════════════
// PAGE - Wizard Abra Onboarding
// Wrapper pour le wizard d'onboarding complet
// ═══════════════════════════════════════════════════════════════════════════════

import React from 'react';
import { useNavigate } from 'react-router-dom';
import WizardAbraOnboarding from '../../components/onboarding/WizardAbraOnboarding';

export default function WizardAbraPage() {
  const navigate = useNavigate();
  
  const handleComplete = (data) => {
    console.log('Wizard completed with data:', data);
    navigate('/cockpit-pro');
  };
  
  const handleSkip = () => {
    navigate('/cockpit-pro');
  };
  
  return (
    <WizardAbraOnboarding 
      onComplete={handleComplete}
      onSkip={handleSkip}
    />
  );
}
